import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { DialogBox, DialogBoxFooterType, NoLink, SelectInput, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { model } from "./../data";
import {
    getAgBytesErrorClassNames,
    mapToPicklistValue,
    prepareSelectableOptions,
} from "~/admin/utils";
import { messages } from "~/admin/agBytes/i18n-messages";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
import { adminData, GUID, ID, NAME, VALUE } from "~/admin/data";

const PROPS_PRODUCT_NAME = "name";

class ProductList extends Component {
    static propTypes = {
        apiErrors: PropTypes.any,
        record: PropTypes.array,
        formatMessage: PropTypes.func,
        toggleModal: PropTypes.func,
        renderDeleteModal: PropTypes.func,
        onChange: PropTypes.func,
        options: PropTypes.array,
        onAdd: PropTypes.func,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        deleteItem: PropTypes.func,
        isEditing: PropTypes.bool,
        isDeleting: PropTypes.bool,
        editData: PropTypes.object,
        showInactiveProducts: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            editOptions: [],
            editingItem: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { record, options } = nextProps;
        if (record && record.length > 0) {
            if (options) {
                this.initializeProductData(nextProps);
            }
        }
    }

    initializeProductData = ({ record = [], options }) => {
        if (record) {
            return record.map((recordItem) => {
                const selectedProductName = _.find(
                    options,
                    (product) => product.guid === recordItem[model.PROPS_PRODUCT_GUID]
                );
                recordItem[NAME] = selectedProductName && selectedProductName[NAME];
                return recordItem;
            });
        }
        return record;
    };

    initializeProducts = (options) => {
        this.setState({
            editOptions: prepareSelectableOptions(options, {
                guid: GUID,
                label: NAME,
                id: ID,
            }),
        });
    };

    onEdit = (record, index) => {
        this.initializeProducts(this.props.options);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [model.PROPS_PRODUCT_GUID],
                key: GUID,
            },
            {
                name: [NAME],
                key: VALUE,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.initializeProducts(this.props.options);
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const {
            formatMessage,
            isEditing,
            editData,
            onAddOrEditItem,
            toggleModal,
            showInactiveProducts,
        } = this.props;
        return (
            <DialogBox
                action="save"
                actionDisabled={!editData[model.PROPS_PRODUCT_GUID]}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                forceOverflow
                isOpen={isEditing}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.product
                )}
            >
                <SelectInput
                    required
                    tabIndex={0}
                    autoFocus
                    optionIsHiddenKey={showInactiveProducts ? null : adminData.PROPS_ACTIVE_YN}
                    openOnFocus={false}
                    options={this.state.editOptions}
                    placeholderText={formatMessage(messages.productName)}
                    value={mapToPicklistValue({
                        options: this.state.editOptions,
                        selectedGuid: editData[model.PROPS_PRODUCT_GUID],
                    })}
                    containerClassNames={["product-list-dropdown"]}
                    onChange={(value) => {
                        this.props.onChange({
                            [model.PROPS_PRODUCT_GUID]: value == null ? "" : value.guid,
                            [NAME]: value == null ? "" : value.name,
                        });
                    }}
                />
            </DialogBox>
        );
    };

    render() {
        const { record, formatMessage } = this.props;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {record && record.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={record}
                        columns={{
                            [PROPS_PRODUCT_NAME]: {
                                title: formatMessage(messages.name),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {this.props.renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        classNames={getAgBytesErrorClassNames(15, this.props.apiErrors, [
                            "add-link",
                        ])}
                        label={createAddLinkLabelText(formatMessage, messages.product)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(ProductList);
